/* eslint-disable react/prop-types */
import { Rating, TripadvisorRating } from '@bwoty-web/ui-kit';
import Title from '../../../common/title';
import Subtitle from '../../../common/subtitle';
import KeySellingPointList from '../../../common/keySellingPointList';
import './titles.scss';

const Titles = ({ hotelName, ratings, geographical, usps, isGlobe }) => {
  return (
    <div className="gw-hotel-info-titles">
      <div className="gw-hotel-info-titles__title-rating-container">
        <Title className="gw-hotel-info-titles__title">{hotelName}</Title>
        <Rating
          className="gw-hotel-info-titles__hotel-standard"
          rating={ratings.standard}
          responsive
        />
        {isGlobe && (
          <TripadvisorRating
            className="gw-hotel-info-titles__ratings"
            rating={ratings?.tripAdvisor?.value}
          />
        )}
        <Subtitle
          className="gw-hotel-info-titles__subtitle"
          geographical={geographical}
        />
      </div>
      <KeySellingPointList
        ksps={usps}
        className="gw-hotel-info-titles__key-selling-points"
        checkmark={!isGlobe}
      />
    </div>
  );
};

export default Titles;
